import { COLORS } from '@btime/constants'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import { useForm } from '../_load/FormLoader'
import Markdown from '../../../../components/presentation/Markdown'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'

const GeneralPanel = () => {
  const { t } = useTranslation('serviceOrders')
  const form = useForm()

  const title = prop('name', form)
  const desc = prop('description', form)

  return (
    <div>
      <Panel noMargin lineBorder>
        <Title size="h2">{title}</Title>
        <Markdown color={COLORS.dark3}>{desc}</Markdown>
      </Panel>
      <Separator weight={4} />
    </div>
  )
}

export default GeneralPanel
